import { useCallback, useSyncExternalStore } from 'react';

/**
 * "Reduce motion" preference, for people who find animations distracting or dizzying.
 * Sets a class on <html> that the theme uses to switch transitions and animations off
 * (see theme.ts). Stored per device.
 */
const KEY = 'pd.reduceMotion';
const CLASS = 'pd-reduce-motion';
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === 'on';
  } catch {
    return false;
  }
}

export function applyReduceMotion(on: boolean = read()) {
  document.documentElement.classList.toggle(CLASS, on);
}

export function useReduceMotion() {
  const on = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    read,
    () => false,
  );
  const set = useCallback((next: boolean) => {
    try {
      if (next) localStorage.setItem(KEY, 'on');
      else localStorage.removeItem(KEY);
    } catch {
      /* private mode: the change still applies for this visit */
    }
    applyReduceMotion(next);
    listeners.forEach((l) => l());
  }, []);
  return { reduceMotion: on, set };
}
